// Risk meter color utilities

// Maps a risk score to a hex color
// Score ranges from -2 (very early) to 3 (significantly late)
export function getScoreColor(score: number): string {
    if (score <= -1.5) return '#4EA72E'; // very early (dark green)
    if (score <= -0.5) return '#B5E6A2'; // early (light green)
    if (score <= 0.5) return '#C1F0C8';  // on schedule (pale green)
    if (score <= 1.5) return '#FFFF00';  // slightly late (yellow)
    if (score <= 2.5) return '#FFC000';  // moderately late (orange)
    return '#C00000';                     // significantly late (red)
}

// Color for items that haven't started yet
export const NOT_STARTED_COLOR = '#D3D3D3';

// Maps buffer/overall score (-2 to 2) to a hex color
// Uses same colors as phase scores but shifted: 0 maps to yellow (phase 1), etc.
export function getBufferOverallColor(score: number): string {
    if (score <= -1.5) return '#4EA72E'; // -2: same as phase -2 (dark green)
    if (score <= -0.5) return '#B5E6A2'; // -1: same as phase -1 (light green)
    if (score <= 0.5) return '#FFFF00';  // 0: same as phase 1 (yellow)
    if (score <= 1.5) return '#FFC000';  // 1: same as phase 2 (orange)
    return '#C00000';                     // 2: same as phase 3 (red)
}

// Maps buffer/overall score to an rgba color with specified alpha
export function getBufferOverallColorWithAlpha(score: number, alpha: number): string {
    const hex = getBufferOverallColor(score);
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
